import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { Datasets as DatasetsInner } from "./Datasets";

// Wrap Datasets with DatatableContextProvider for the new filter bar pattern
const Datasets = () => (
  <DatatableContextProvider>
    <DatasetsInner />
  </DatatableContextProvider>
);

export { Datasets };
export * from "./TableList";
export * from "./DatasetsDetails";
